import { render, staticRenderFns } from "./MonthlyEISCIMB.vue?vue&type=template&id=39a72754"
import script from "./MonthlyEISCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlyEISCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports